import React from "react";
import {VFlex, VFlexSS} from "./UtilityTags";
import {Box, Grid, Heading, Text} from "@chakra-ui/react";
import Mtn from "./Mtn";
import BlueBlurBg from "../../assets/img/Blue Blur.webp";
import OrangeBlurBg from "../../assets/img/Orange Blur.jpg";
import Product1 from "../../assets/products/cubecert_made_in_usa.png";
import Product2 from "../../assets/products/cubecert_cmmc.png";
import Product3 from "../../assets/products/cubecert_wind_invisible.png";
import Product4 from "../../assets/products/Pill-Bottle-opt.png";

const ProductCard = ({bgImg, img, title, text, ...rest}) => {
  return (
    <VFlex
      w="200px"
      gap={2}
      {...rest}
    >
      <Box sx={{
             position:"relative",
             width: '200px',
             height: '200px',
             flexShrink: 0,
             overflow:"hidden",
             borderRadius:"20px",
             backgroundColor: '#0a0a0a',
             _hover:{ ".bgImage": { opacity: 1 } }
           }}>
        <Box
          className="bgImage"
          sx={{
            backgroundImage: bgImg,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            position: 'absolute',
            width: '200%',
            height: '200%',
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%) rotate(0deg)",
            opacity: 0,
            transition:'opacity 0.7s',
            animation: 'rotation 7s infinite linear',
            '@keyframes rotation': {
              'from': {
                transform: 'translate(-50%, -50%) rotate(0deg)',
              },
              'to': {
                transform: 'translate(-50%, -50%) rotate(359deg)',
              }
            }
          }}
        />
        <Mtn.InFromRight
          isChild
          className='productImg'
          transition={{ type: "tween", ease: "easeInOut" }}
          sx={{
            backgroundImage: img,
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            position:'absolute',
            inset: '12px',
          }}/>
      </Box>
      <Heading size='sm'>{title}</Heading>
      <Mtn.InFromBelow><Text>{text}</Text></Mtn.InFromBelow>
    </VFlex>
  )
};

const ProductCards = ({bgImg, img, title, text, ...rest}) => {
  return (
    <Mtn.Box
      sx={{
        display:'grid',
        gridTemplateColumns:["repeat(1, 1fr)", "repeat(2, 1fr)", "repeat(2, 1fr)", "repeat(4, 1fr)"],
        // w:"100%",
        gap:'40px',
        alignItems: "start",
        justifyItems: "center",

      }}
      id='product-cards'
      variants={{
        hidden: {},
        show: {
          transition: {
            duration: .4,
            delayChildren: .1,
            staggerChildren: .1,
            // staggerDirection: 1
          }
        }
      }}
      initial="hidden"
      whileInView='show'
      viewport={{once: false}}
    >
      <ProductCard bgImg={BlueBlurBg} img={Product1}
                                title='Made in the USA Manufacturing'
                                text='Verify product origin and strengthen trust in American-made products with secure digital identity, QR code authentication and logistics tracking.'/>
      <ProductCard bgImg={OrangeBlurBg} img={Product2}
                                title='CMMC & Supply Chain Compliance'
                                text='Improve supply chain visibility and support CMMC readiness with secure, tamper-proof QR code tracking and real time reporting.'/>
      <ProductCard bgImg={BlueBlurBg} img={Product3}
                                title='Brand Protection & Logistics Tracking'
                                text='Protect against counterfeiting with digital authentication and real-time transport tracking across the supply chain.'/>
      <ProductCard bgImg={OrangeBlurBg} img={Product4}
                                title='Medical & Health'
                                text='Ensure consumers know that your prescriptions are authentic and made in the U.S.A.'/>
    </Mtn.Box>
  )
};

export default ProductCards;